module.exports = __webpack_public_path__ + "img/brandstore_banner.20557d9d.png";